// extracted by mini-css-extract-plugin
module.exports = {"reasonToSend":"reason_reasonToSend__3z-vJ","featureContent":"reason_featureContent__jSkHi","reason":"reason_reason__tqTOK","closeCollection":"reason_closeCollection__8yrlo"};